// src/components/FooterNav.jsx
import {
  FaChartLine,
  FaFileInvoice,
  FaCashRegister,
  FaClipboardList,
  FaEllipsisH,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const navItems = [
  { label: "Dashboard", icon: <FaChartLine />, path: "/restaurant/dashboard" },
  { label: "Receipt", icon: <FaFileInvoice />, path: "/restaurant/receipt" },
  { label: "Counter", icon: <FaCashRegister />, path: "/restaurant/counter" },
  { label: "Orders", icon: <FaClipboardList />, path: "/restaurant/orders" },
  { label: "More", icon: <FaEllipsisH />, path: "/restaurant/more" },
];

const FooterNav = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow md:hidden z-50">
      <div className="flex justify-around items-center py-2">
        {navItems.map((item, index) => (
          <button
            key={index}
            className="flex flex-col items-center text-xs text-gray-700 hover:text-primary"
            onClick={() => navigate(item.path)}
          >
            <div className="text-lg">{item.icon}</div>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FooterNav;
